const stats = [
  { value: '2000+', label: '收录大赛作品' },
  { value: '30+', label: '大赛类型覆盖' },
  { value: '每日更新', label: '内容持续追踪' },
];

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm-toned%20artistic%20composition%20with%20soft%20stage%20spotlights%20and%20flowing%20ribbons%20of%20light%20in%20coral%20and%20amber%20hues%2C%20elegant%20modern%20atmosphere%2C%20subtle%20geometric%20patterns%2C%20warm%20gradient%20background%2C%20no%20text%2C%20no%20people%2C%20clean%20sophisticated%20design%2C%20high%20resolution%2C%20editorial%20quality&width=1600&height=900&seq=hero-bg-daily-contest-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500/20 text-primary-300 border border-primary-400/30 backdrop-blur-sm mb-5">
              🔥 每日大赛入口 — 热门大赛视频内容专题
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-heading leading-tight mb-4">
              每日大赛入口
              <br />
              <span className="text-primary-300">各类大赛作品介绍与类型大全</span>
            </h1>

            <p className="text-base md:text-lg text-background-200/90 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              一站式每日大赛作品介绍平台，覆盖舞蹈、音乐、创意、科技等30+大赛类型。
            </p>
            <p className="text-sm md:text-base text-background-300/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              每日追踪最新大赛视频动态，通过每日大赛列表和每日大全帮你快速定位感兴趣的内容，
              无论是寻找灵感创作还是欣赏优秀作品，每日大赛入口都是你的首选在线平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-white font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-300/70 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热门排行
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-white/10 text-white font-medium text-sm border border-white/20 hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-price-tag-3-line"></i>
                浏览大赛类型
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[360px] md:w-[380px] md:h-[460px] rounded-2xl overflow-hidden border-2 border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20representing%20creative%20competition%20and%20performance%2C%20flowing%20dynamic%20shapes%20in%20warm%20coral%20and%20gold%20tones%2C%20elegant%20curves%20reminiscent%20of%20stage%20curtains%20and%20spotlights%2C%20modern%20minimalist%20style%2C%20soft%20gradients%2C%20sophisticated%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20high%20end%20editorial%20design&width=800&height=1000&seq=hero-visual-daily-contest-02&orientation=portrait"
                alt="每日大赛入口主视觉 — 创意大赛作品展示"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}